"use strict";

var angular = require("angular");

/*
 * Modified from jQuery-UI's scrollParent implementation
 */
module.exports = /* @ngInject */ function($document) {
  return function scrollParent(element) {
    var position = element.css("position"),
      excludeStaticParent = position === "absolute",
      overflowRegex = /(auto|scroll)/,
      result = element
        .parents()
        .filter(function() {
          var parent = angular.element(this);
          if (excludeStaticParent && parent.css("position") === "static") {
            return false;
          }
          return overflowRegex.test(
            parent.css("overflow") +
              parent.css("overflow-y") +
              parent.css("overflow-x")
          );
        })
        .eq(0);

    return position === "fixed" || !result.length
      ? angular.element(element[0].ownerDocument || $document)
      : result;
  };
};



// WEBPACK FOOTER //
// ./app/ui/utils/scrollParent.js